import axios from "axios";
import { LOCAL_STORAGE_TOKENS } from "../utils/constants";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const API_ENDPOINT_AUTH_SERVICE =
  process.env?.REACT_APP_PROFILE === "prod"
    ? process.env.REACT_APP_API_ENDPOINT
    : process.env.REACT_APP_API_ENDPOINT_AUTH_SERVICE;
const API_ENDPOINT_EXTRACT_SERVICE = process.env.REACT_APP_API_ENDPOINT;
const { localKey_language_key } = LOCAL_STORAGE_TOKENS;
export default axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": localStorage.getItem(localKey_language_key),
  },
});

export const axiosAuthService = axios.create({
  baseURL: API_ENDPOINT_AUTH_SERVICE,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": localStorage.getItem(localKey_language_key),
  },
});

export const axiosPrivate = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": localStorage.getItem(localKey_language_key),
  },
});

axiosPrivate.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${localStorage.microsoft_code}`,
    };
    return config;
  },
  (error) => Promise.reject(error)
);
export const axiosExtractService = axios.create({
  baseURL: API_ENDPOINT_EXTRACT_SERVICE,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": localStorage.getItem(localKey_language_key),
  },
});

export const axiosBlobPrivate = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": localStorage.getItem(localKey_language_key),
  },
  responseType: "blob",
});

axiosBlobPrivate.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${localStorage.microsoft_code}`,
    };
    return config;
  },
  (error) => Promise.reject(error)
);

export const createEmp = (e) => {
  e.preventDefault();

  const payload = {};

  axios
    .post(`${API_ENDPOINT}create-emp/`, payload)
    .then(function (response) {
      alert(response.data + " sucessfully");
    })
    .catch(function (error) {
      console.log("err " + error);
    });
};
